(function() {
    'use strict';

    var module = angular.module('doclr.praktijk', ['doclr.resources.api']);

    module.directive('verwijderPraktijk', function($window, $uibModal, praktijkContext, Praktijk) {
        return {
            transclude: true,
            template: '<a ng-click="verwijderPraktijk()" ng-transclude></a>',
            controller: function($scope) {
                $scope.verwijderPraktijk = function() {

                    $scope.confirmmodal  = {
                        title : doclrVertaal.instant('praktijk.remove.confirmmodal.title'),
                        question : doclrVertaal.instant('praktijk.remove.confirmmodal.questsion')
                    };

                    var modalInstance = $uibModal.open({
                        templateUrl: '/partials/components/confirmmodal.html',
                        scope : $scope
                    });

                    modalInstance.result.then(function() {
                        Praktijk.verwijderPraktijk(praktijkContext.id).then(function() {
                            $window.location.href = '/superuser';
                        });
                    });
                };
            }
        };
    });
})();


